// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__LvL7b","box":"WorkspacesBox_box__2ic12","node":"WorkspacesBox_node__17Ijz"};